module.exports = __webpack_public_path__ + "img/01.7b0083dd.jpg";